<template>
  <form @submit.prevent="submit" class="container mt-lg-5 mb-5 d-flex flex-column gap-3 w-100">
    <div class="d-flex flex-column justify-content-center align-items-start gap-2 mb-2">
      <h2 class="m-0">{{ $t('crearNuevoFormulario') }}</h2>
      <div class="d-flex flex-row gap-2 align-items-center flex-wrap">
        <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
            :class="{ 'checkbox-custom-pill-2-checked': newForm.Anonimo, 'checkbox-custom-pill-2': !newForm.Anonimo}"
            style="cursor: pointer; min-height: 35px;"
            @click="newForm.Anonimo = !newForm.Anonimo">
          <input class="checkbox-custom-2" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="newForm.Anonimo" >
          <span>{{ $t('anonimo') }}</span>
        </div>

        <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
            :class="{ 'checkbox-custom-pill-2-checked': newForm.ConAccesoRestringido, 'checkbox-custom-pill-2': !newForm.ConAccesoRestringido}"
            style="cursor: pointer; min-height: 35px;"
            @click="newForm.ConAccesoRestringido = !newForm.ConAccesoRestringido">
          <input class="checkbox-custom-2" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="newForm.ConAccesoRestringido" >
          <span>{{ $t('accesoRestringido') }}</span>
        </div>
        
        <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
            :class="{ 'checkbox-custom-pill-2-checked': newForm.ConEdicionDeCompletado, 'checkbox-custom-pill-2': !newForm.ConEdicionDeCompletado}"
            style="cursor: pointer; min-height: 35px;"
            @click="newForm.ConEdicionDeCompletado = !newForm.ConEdicionDeCompletado">
          <input class="checkbox-custom-2" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="newForm.ConEdicionDeCompletado" >
          <span>{{ $t('conEdicionDeCompletado') }}</span>
        </div>
        
        <div class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-3"
            :class="{ 'checkbox-custom-pill-2-checked': newForm.ConVisualizacionRestringida, 'checkbox-custom-pill-2': !newForm.ConVisualizacionRestringida}"
            style="cursor: pointer; min-height: 35px;"
            @click="newForm.ConVisualizacionRestringida = !newForm.ConVisualizacionRestringida">
          <input class="checkbox-custom-2" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="newForm.ConVisualizacionRestringida" >
          <span>{{ $t('conVisualizacionRestringida') }}</span>
        </div>
        
        <div v-if="!newForm.Anonimo" class="d-inline-flex align-items-center gap-1 rounded-pill p-0 pe-2 sombra-sm"
            :class="{ 'checkbox-custom-pill-2-checked': newForm.ConRespuesta, 'checkbox-custom-pill-2': !newForm.ConRespuesta}"
            style="cursor: pointer; min-height: 35px;">
          <input class="checkbox-custom-2" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="newForm.ConRespuesta" @click="newForm.ConRespuesta = !newForm.ConRespuesta">
          <span @click="newForm.ConRespuesta = !newForm.ConRespuesta">{{ $t('conRespuesta') }}</span>

          <!-- Divider Vertical -->
          <div v-if="newForm.ConRespuesta" class="col-12 ms-2" style="border-right: 2px solid #b88a44; height: 36px; width:1px"></div>
          <div v-if="newForm.ConRespuesta && !newForm.Anonimo" class="d-flex flex-row gap-1 align-items-center">
            <select v-model="newForm.AQuienesResponden" class="form-select border-0" style="background-color: #f3cb7a;" required>
              <option value="Subordinados">{{ $t('subordinados') }}</option><!--Indica que los autorizados pueden responder a sus subordinados-->
              <option value="Todos">{{ $t('todos') }}</option><!--Indica que los autorizados pueden responder a todos-->
            </select>
            
            <div class="tooltip-container d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12" y2="8"></line>
              </svg>
              <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 250px;">
                <p class="m-0 fs-8 text-secondary">{{ $t('quienesLesApareceParaResponder') + ' ' + $t(newForm.AQuienesResponden.toLowerCase()) }}</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Contenedor de la imagen o icono -->
    <div class="d-flex justify-content-center align-items-center bg-light card-img-top rounded-4 position-relative sombra-sm" style="height: 200px; cursor: pointer;" @click="selectImage">
      <!-- Mostrar la imagen si ya está cargada -->
      <img v-if="newForm.PortadaUrl" :src="newForm.PortadaUrl" alt="Imagen seleccionada" class="rounded-4 w-100 h-100 object-fit-cover">
      
      <!-- Mostrar el icono si no hay imagen -->
      <i v-else class="bi bi-image fs-1 text-secondary"></i>

      <!-- Input oculto para subir la imagen -->
      <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" class="d-none">

      <!-- Loader sobre todo -->
      <div v-if="loadingFile" 
          class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75">
        <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
      </div>
    </div>
    <!-- Campos del Formulario -->
    <div>
      <label for="nombreFormulario">{{ $t('nombreFormulario') }}</label>
      <textarea class="form-control sombra-sm" id="nombreFormulario" v-model="newForm.NombreFormulario" rows="1" oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'" style="height: 38px; resize: none;" maxlength="200" required></textarea>
    </div>

    <div>
      <label for="descripcion">{{ $t('descripcion') }}</label>
      <textarea id="descripcion" v-model="newForm.Descripcion" class="form-control sombra-sm" style="height: 120px; resize: none;" maxlength="1000" required></textarea>
      <div class="mt-2 text-end">
        <span>{{ newForm.Descripcion.length }}/1000 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
      </div>
    </div>
    
    <!-- Divider -->
    <div class="col-12 my-3" style="border-top: 1px solid #ddd; height: 1px"></div>

    <!-- Observaciones -->
    <label>{{ $t('observaciones') }}:</label>
    <div v-for="(observacion, indexObs) in newForm.Observacions" :key="indexObs" class="p-3 border border-light-subtle bg-body-secondary rounded d-flex flex-row gap-3">
      <div class="d-flex flex-column">
        <svg width="20" height="20" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="moveUp(indexObs)" style="cursor: pointer">
          <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#999" transform="scale(1, -1) translate(0, -24)"/>
        </svg>
        <h3 class="text-center mb-1 text-body-tertiary">{{ observacion.NroOrden }}</h3>
        <svg width="20" height="20" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="moveDown(indexObs)" style="cursor: pointer">
          <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#999"/>
        </svg>
      </div>
      <div class="w-100">
        <div class="mb-1 d-flex flex-row gap-2 justify-contents-center align-items-center">
          <textarea
            class="form-control sombra-sm"
            id="exampleTextarea"
            v-model="observacion.NombreObservacion"
            :placeholder="$t('ingreseTituloObservacion')"
            rows="1"
            oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'"
            style="height: 38px; resize: none;"
            maxlength="200" required
          ></textarea>
          <select v-model="observacion.IdTipoObservacion" style="max-width: 250px; width: 30%;" class="form-select">
            <option v-for="tipo in tiposObservacion" :key="tipo.IdTipoObservacion" :value="tipo.IdTipoObservacion">
              {{ $t(`${ tipo.tipoObservacion.replace(/\s+/g, '')}`) }}
            </option>
          </select>
        </div>

        <div>
          <label for="descripcion">{{ $t('descripcion') }}</label>
          <textarea id="descripcion" v-model="observacion.Descripcion" class="form-control sombra-sm" style="height: 80px; resize: none;" maxlength="1000"></textarea>
          <div class="text-end">
            <span>{{ observacion.Descripcion.length }}/1000 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
          </div>
        </div>
        <!-- Divider -->
        <div class="col-12 my-3" style="border-top: 1px solid #ddd; height: 1px"></div>

        <!-- Mostrar campos diferentes según el tipo de observación -->
        <div v-if="observacion.IdTipoObservacion === '6A89FB8F-18B7-45B7-8015-AB1445BBAD4A'.toLowerCase()"><!--Texto Corto-->
          <textarea
            class="form-control sombra-sm"
            id="exampleTextarea"
            placeholder="Texto corto"
            rows="1"
            oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'"
            style="height: 38px; resize: none;" disabled
          ></textarea>
        </div>

        <div v-if="observacion.IdTipoObservacion === '9d19533b-3d29-4ff3-9be4-0ec902db6191'.toLowerCase()"><!--Fecha-->
          <input type="date" class="form-control sombra-sm" id="fecha" placeholder="Selecciona una fecha">
        </div>

        <div v-if="observacion.IdTipoObservacion === '56cdebd4-89e8-4bb2-a26e-8f366c3f4159'.toLowerCase()"><!--Hora-->
          <input type="time" class="form-control sombra-sm" id="hora" placeholder="Selecciona una hora">
        </div>

        <div v-if="observacion.IdTipoObservacion === '4BA48D01-AFEB-4D81-87D2-67FA07187CB5'.toLowerCase()" class="d-flex flex-column gap-2"><!--Opciones-->
          <!-- Items de Observación -->
          <label v-for="(item, indexItem) in observacion.ItemsObservacions" :key="indexItem" class="d-flex flex-row m-0 ms-1 align-items-center gap-1 text-wrap">
            <input type="radio" :value="indexItem" v-model="observacion.OpcionSeleccionada" class="text-wrap" disabled/>
            {{ item.NombreItem }}
            <button type="button" class="btn btn-sm ms-2 fs-8" @click="removeItem(indexObs, indexItem)">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="stroke:gray">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </label>

          <!-- Mostrar el campo de texto y botones de agregar y cancelar -->
          <div v-if="observacion.showAddItem" class="d-flex flex-row gap-2 align-items-center">
            <!-- <input type="text" v-model="observacion.newItemName" class="form-control sombra-sm fs-6" placeholder="Ingrese el nuevo item" maxlength="200"/> -->
            <textarea class="form-control sombra-sm fs-6" id="nombreFormulario" v-model="observacion.newItemName" rows="1" placeholder="Ingrese el nuevo item" oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'" style="height: 38px; resize: none;" maxlength="200" required></textarea>
            <button type="button" class="btn btn-primary fs-6" @click="confirmAddItem(indexObs)">{{ $t('agregar') }}</button>
            <button type="button" class="btn btn-secondary fs-6" @click="cancelAddItem(indexObs)">{{ $t('cancelar') }}</button>
          </div>
          <!-- Botón Agregar Item -->
          <button type="button" class="btn text-start text-secondary fs-6 p-1" style="width: 150px;" @click="toggleAddItem(indexObs)">
            <svg class="mb-1" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('agregarItem') }}
          </button>
        </div>

        <div v-if="observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()" class="d-flex flex-column gap-2"><!--Rango-->
          <div class="d-flex flex-row gap-2 align-items-center">
            <label for="minRangeInput" class="m-0">{{ $t('min') }}:</label>
            <input type="number" id="minRangeInput" v-model="observacion.ItemsObservacions.find(i => i.NombreItem === 'Minimo').ValorDeRango" class="form-control sombra-sm" />

            <label for="maxRangeInput" class="m-0">{{ $t('max') }}:</label>
            <input type="number" id="maxRangeInput" v-model="observacion.ItemsObservacions.find(i => i.NombreItem === 'Maxima').ValorDeRango" class="form-control sombra-sm" />

            <label for="stepValueInput" class="m-0">{{ $t('step') }}:</label>
            <input type="number" id="stepValueInput" v-model="observacion.ItemsObservacions.find(i => i.NombreItem === 'StepValue').ValorDeRango" step="0.1" class="form-control sombra-sm" />
          </div>

          <span>{{ currentValue }}</span>
          
          <div class="d-flex justify-content-between gap-2">
            <!-- Valor mínimo -->
            <span>{{ observacion.ItemsObservacions.find(i => i.NombreItem === 'Minimo').ValorDeRango }}</span>
            
            <!-- Slider de rango -->
            <input type="range" class="form-range" :min="observacion.ItemsObservacions.find(i => i.NombreItem === 'Minimo').ValorDeRango" :max="observacion.ItemsObservacions.find(i => i.NombreItem === 'Maxima').ValorDeRango" :step="observacion.ItemsObservacions.find(i => i.NombreItem === 'StepValue').ValorDeRango" v-model="currentValue" id="customRange3" disabled/>
            
            <!-- Valor máximo -->
            <span>{{ observacion.ItemsObservacions.find(i => i.NombreItem === 'Maxima').ValorDeRango }}</span>
          </div>
        </div>

        <div v-if="observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase()" class="d-flex flex-column gap-4"><!--Numero-->
          <div class="input-group mb-3">
            <span class="p-2 rounded-start-2 sombra-sm fondo-terciario texto-principal border-end border-2 borde-principal" id="basic-addon1">Valor</span>
            <input class="form-control sombra-sm" type="number" v-model="observacion.Valores[0].ValorObservado" style="max-width: 100px;" disabled/>
          </div>
        </div>

        <div v-if="observacion.IdTipoObservacion === 'e42de6bc-9113-4ba6-8818-49fa8a2c0c6f'.toLowerCase()"><!--Condicion Observable-->
          <div class="btn-group w-100" role="group" aria-label="Basic radio toggle button group" style="background-color: #DFBA6E; height: 50px;">

            <input type="radio" class="btn-check" :name="'observacion_' + indexObs" id="btnradio1" autocomplete="off" disabled>
            <label class="btn border-end border-start d-flex align-items-center justify-content-center" for="btnradio1">{{ $t('Si') }}</label>

            <input type="radio" class="btn-check" :name="'observacion_' + indexObs" id="btnradio2" autocomplete="off" disabled>
            <label class="btn border-end border-start d-flex align-items-center justify-content-center" for="btnradio2">{{ $t('No') }}</label>

            <input type="radio" class="btn-check" :name="'observacion_' + indexObs" id="btnradio3" autocomplete="off" disabled>
            <label class="btn border-end border-start d-flex align-items-center justify-content-center" for="btnradio3">{{ $t('No Observable') }}</label>

          </div>
        </div>
        
        <div v-if="observacion.IdTipoObservacion === 'bb1c6568-f8ea-42bc-9133-375f86fa2415'.toLowerCase()"><!--Archivo-->
          <label>{{ $t('subirArchivo') }}</label>
          <input 
            type="file" 
            class="form-control sombra-sm" 
            @change="handleFileUpload($event, indexObs)" 
            :id="'archivo-' + indexObs" 
            accept=".pdf,.doc,.docx,.jpg,.png,.txt,.zip" disabled/>
          <small class="text-muted">{{ $t('tamanoMaximo') }}: 50MB</small>
          <div v-if="observacion.archivo && observacion.archivo.nombre" class="mt-2">
            <p class="m-0">{{ $t('archivoSeleccionado') }}: {{ observacion.archivo.nombre }}</p>
          </div>
        </div>

        <div v-if="observacion.IdTipoObservacion === '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase()" class="d-flex flex-column gap-2 w-100"><!--Evaluado-->
          <div>
            <label >{{ $t('evaluado') }} {{ $t('seleccionarTipoATraer') }}:</label>
            <div class="d-flex flex-row gap-2">
              <select style="width: 100%;" class="form-select" v-model="observacion.TipoEvaluado" required>
                <option value="Profesor">
                  {{ $t('profesor') }}
                </option>
                <option value="Alumno">
                  {{ $t('alumno') }}
                </option>
                <option value="Familiar">
                  {{ $t('familiar') }}
                </option>
                <option value="Curso o Grupo">
                  {{ $t('cursoGrupo') }}
                </option>
                <option value="Personalizado">
                  {{ $t('personalizado') }}
                </option>
              </select>
            </div>
          </div>
          
          
          <!-- Botón Agregar Eleccion de Materia -->
          <button v-if="!observacion.ConEleccionMateria && observacion.TipoEvaluado == 'Profesor'" class="btn text-start text-secondary fs-5 p-1" style="width: 300px;" @click="observacion.ConEleccionMateria = true">
            <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('agregarEleccionMateria') }}
          </button>

          <div v-if="observacion.ConEleccionMateria">
            <label >{{ $t('materia') }}:</label>
            <div class="d-flex flex-row gap-2">
              <select style="width: 100%;" class="form-select" disabled>
              </select>
              
              <!-- Botón de eliminar, inicialmente oculto -->
              <button class="btn pb-2"
                      @click="observacion.ConEleccionMateria = false">
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="stroke:gray">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          <div v-if="observacion.TipoEvaluado == 'Personalizado'">
            <!-- Botón Agregar Eleccion de Materia -->
            <button v-if="!observacion.AgregarPersona" class="btn text-start text-secondary fs-5 p-1" style="width: 300px;" @click="observacion.AgregarPersona = true">
              <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t('agregarPersona') }}
            </button>
            
            <div v-if="observacion.AgregarPersona" class="d-flex flex-column gap-2">
              <p class="m-0">{{ $t('agregarPersona') }}:</p>
              <div class="position-relative d-flex flex-row gap-2 w-100">
                <input type="text" v-model="observacion.searchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control sombra-sm w-100" @input="filterPersonas(observacion)"/>
                <ul v-if="observacion.filteredPersonas.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%; top: 100%;">
                  <li v-for="evaluado in observacion.filteredPersonas"  :key="evaluado.idPersona"  class="list-group-item list-group-item-action" @click="selectPersona(evaluado, observacion)" style="cursor: pointer;">
                    {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                  </li>
                </ul>
                <!-- Botones de acción -->
                <div class="d-flex flex-row gap-2">
                  <button type="button" class="btn btn-success" @click="agregarPersona(observacion)">{{ $t('guardar') }}</button>
                  <button type="button" class="btn btn-secondary p-0 px-2" @click="cancelarAgregarPersona(observacion)">{{ $t('cancelar') }}</button>
                </div>

                <div v-if="loadingPersonas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                  <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
                </div>
              </div>
            </div>

            <!-- Lista de personas seleccionadas -->
            <div v-if="observacion.PersonasSeleccionadas">
              <div v-if="observacion.PersonasSeleccionadas.length > 0">
                <p class="m-0">{{ $t('personasSeleccionadas') }}:</p>
                <ul class="list-group">
                  <li
                    v-for="(persona, index) in observacion.PersonasSeleccionadas"
                    :key="persona.IdPersona"
                    class="list-group-item d-flex justify-content-between align-items-center p-1 ps-3"
                  >
                    {{ persona.Apellido + ' ' + persona.Nombre }}
                    <!-- Botón de eliminar de la lista-->
                    <button type="button" class="btn pb-2" @click="eliminarPersona(index, observacion)">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="stroke:gray">
                        <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
          
        <!-- Botón Agregar Item -->
        <button type="button" v-if="!observacion.ConComentario && observacion.IdTipoObservacion != '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase()" class="btn text-start text-secondary fs-5 p-1" style="width: 250px;" @click="observacion.ConComentario = true">
          <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('agregarComentario') }}
        </button>
        <div v-if="observacion.ConComentario" class="position-relative" style="width: 100%;">
          <label for="descripcion">{{ $t('comentario') }}</label>
          <textarea id="descripcion" class="form-control sombra-sm bg-secondary-subtle" style="height: 120px; resize: none;" maxlength="500" disabled></textarea>

          <!-- Botón de eliminar, inicialmente oculto -->
          <button type="button" class="btn position-absolute pb-3 eliminar-comentario"
                  @click="observacion.ConComentario = false">
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="stroke:gray">
              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <div class="mt-2 text-end">
            <span>{{ newForm.Descripcion.length }}/500 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
          </div>
        </div>
        <!-- Divider -->
        <div class="col-12 my-3" style="border-top: 1px solid #ddd; height: 1px"></div>

        <div class="d-flex flex-row gap-3 align-items-center justify-content-end">
          <button type="button" class="btn p-0 pb-1" @click="removeObservation(indexObs)">
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="stroke:gray">
              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <!-- Divider Vertical -->
          <div class="col-12" style="border-right: 1px solid #ddd; height: 30px; width:1px"></div>
          <!-- Switch para indicar si la observación es obligatoria -->
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="observacion.Obligatorio" >
            <label class="form-check-label" for="flexSwitchCheckDefault">{{ $t('obligatorio') }}</label>
          </div>
        </div>
      </div>
      
    </div>

    <!-- Botón Agregar Observacion -->
    <button type="button" class="btn text-start text-secondary fs-5 p-1" style="width: 250px;" @click="addObservation">
      <svg class="mb-1" width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M12 6V18" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ $t('agregarObservacion') }}
    </button>
      <div class="d-flex gap-2 mt-4">
        <button type="submit" class="btn btn-success" :disabled="isSaving">{{ $t('guardar') }}</button>
        <button class="btn btn-danger" @click="cancelForm">{{ $t('cancelar') }}</button>
      </div>
  </form>
</template>

<script>
  import { ref, computed, onMounted, toRaw, watch } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const isAddingForm = ref(false);
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const newForm = ref({
      Descripcion: '',
      TituloEleccionEvaluado: '',
      ConEleccionEvaluado: false,
      TipoEvaluado: '',
      ConEleccionMateria: false,
      NivelMateria: '',
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdModificadoPor: null,
      IdCreador: null,
      IdFormulario: null,
      NombreFormulario: '',
      ConAccesoRestringido: false,
      AQuienesResponden: 'Todos',
      Anonimo: false,
      ConEdicionDeCompletado: false,
      ConVisualizacionRestringida: false,
      PortadaUrl: null,
      Observacions: [], // Array de objetos para observaciones
    });
    const tiposObservacion = ref([]);
    const currentValue = ref(3);
    const isSaving = ref(false);
    const persona = ref([]);
    const loadingPersonas = ref(false);
    const loadingCursosGrupos = ref(false);
    const loadingMaterias = ref(false);
    const loadingFile = ref(false);
    const selectedPersona = ref(null);

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'CrearFormularios'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    // Obtener los tipos de observación desde la API
    const fetchTiposObservacion = async () => {
      try {
        const response = await api.get(`api/Observaciones/TipoObservaciones`);
        tiposObservacion.value = response.data;
        console.log(tiposObservacion.value)
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Obtener los tipos de observación desde la API
    const fetchPersonas = async () => {
      try {
        loadingPersonas.value = true;
        let response;
        response = await api.get(`api/Persona/ByEstado?estado=Activo`);
        persona.value = response.data;
        console.log(persona.value)
        loadingPersonas.value = false;
      } catch (error) {
        loadingPersonas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };
    // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = (observacion) => {
      if (!observacion.searchQuery) {
        observacion.filteredPersonas = [];
      } else {
        const query = observacion.searchQuery.toLowerCase();
        observacion.filteredPersonas = persona.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };
    const selectPersona = (evaluado,observacion) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      observacion.searchQuery = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      observacion.filteredPersonas = []; // Limpia la lista filtrada
    };
    const agregarPersona = (observacion) => {
      const persona1 = persona.value.find(
        (p) => `${p.Apellido} ${p.Nombre}` === observacion.searchQuery
      );
      console.log(observacion.searchQuery)
      console.log(persona1)
      if (persona1 && !observacion.PersonasSeleccionadas.some((p) => p.IdPersona === persona1.IdPersona)) {
        observacion.PersonasSeleccionadas.push(persona1);
        observacion.searchQuery = '';
      }
      console.log(observacion.PersonasSeleccionadas)
    };
    const cancelarAgregarPersona = (observacion) => {
      observacion.AgregarPersona = false;
      observacion.searchQuery = '';
      observacion.filteredPersonas = [];
    };
    const eliminarPersona = (index, observacion) => {
      observacion.PersonasSeleccionadas.splice(index, 1);
    };

    const addObservation = () => {
      if (!newForm.value.Observacions) {
        newForm.value.Observacions = []; // Inicializa si no está definido
      }
      // Asignar el primer valor de tiposObservacion como el valor por defecto
      let defaultTipoObservacion = '';
      if(tiposObservacion.value){
        defaultTipoObservacion = tiposObservacion.value.length > 0 ? tiposObservacion.value[0].IdTipoObservacion : '';
      }

      const nextOrderNumber = newForm.value.Observacions.length + 1;
      newForm.value.Observacions.push({
        IdTipoObservacion: defaultTipoObservacion, // Inicializa el tipo de observación
        NombreObservacion: '',
        Descripcion: '',
        NroOrden: nextOrderNumber,
        Obligatorio: false,
        ConComentario: false,
        ItemsObservacions: [], // Asegúrate de inicializar el array de items
        showAddItem: false, // Controla la visibilidad del campo de agregar item
        newItemName: '', // Asegúrate de inicializar el nuevo item
        PersonasSeleccionadas: [],
        AgregarPersona: false,
        filteredPersonas: [],
        searchQuery: '',
      });
    };

    const removeObservation = (index) => {
      if(newForm.value.Observacions){
        newForm.value.Observacions.splice(index, 1);
      }
    };
    const moveUp = (index) => {
      if (index > 0) {
        const current = newForm.value.Observacions[index];
        const previous = newForm.value.Observacions[index - 1];

        // Intercambiar NroOrden
        const tempOrder = current.NroOrden;
        current.NroOrden = previous.NroOrden;
        previous.NroOrden = tempOrder;

        // Reordenar elementos
        newForm.value.Observacions.splice(index - 1, 2, current, previous);
      }
    };
    const moveDown = (index) => {
      if (index < newForm.value.Observacions.length - 1) {
        const current = newForm.value.Observacions[index];
        const next = newForm.value.Observacions[index + 1];

        // Intercambiar NroOrden
        const tempOrder = current.NroOrden;
        current.NroOrden = next.NroOrden;
        next.NroOrden = tempOrder;

        // Reordenar elementos
        newForm.value.Observacions.splice(index, 2, next, current);
      }
    };

    const submit = async () => {
      if (newForm.value.Observacions.length === 0) {
        alert("Por favor, agrega al menos una observación.");
        return;
      }
      // Lógica para guardar el formulario
      try {
        isSaving.value = true;

        // Filtrar observaciones con TipoEvaluado === 'Personalizado'
        newForm.value.Observacions.forEach((obs, index) => {
          if (obs.TipoEvaluado === 'Personalizado') {
            // Si no existe un array para itemsObservacion, inicializarlo
            if (!obs.ItemsObservacions) {
              obs.ItemsObservacions = [];
            }

            // Agregar un nuevo item para cada persona seleccionada
            obs.PersonasSeleccionadas.forEach(persona => {
              obs.ItemsObservacions.push({
                IdItemsObservacion: '00000000-0000-0000-0000-000000000000',
                IdPersona: persona.IdPersona,
              });
            });
            console.log(obs)

            newForm.value.Observacions[index] = obs;
          }
        });
        //console.log(newForm)

        const cleanedObservations = newForm.value.Observacions.map(observacion => {
          return {
            IdTipoObservacion: observacion.IdTipoObservacion,
            NroOrden: observacion.NroOrden,
            NombreObservacion: observacion.NombreObservacion,
            Descripcion: observacion.Descripcion,
            Obligatorio: observacion.Obligatorio,
            ConComentario: observacion.ConComentario,
            TipoEvaluado: observacion.TipoEvaluado,
            ConEleccionMateria: observacion.ConEleccionMateria,
            ItemsObservacions: observacion.ItemsObservacions.map(item => {
              return {
                NombreItem: item.NombreItem,
                ValorDeRango: item.ValorDeRango,
                IdObservacion: observacion.IdObservacion,
                IdItemsObservacion: item.IdItemsObservacion || null,
                IdCurso: item.IdCurso || null,
                IdPersona: item.IdPersona || null
              };
            }),
          };
        });


        if(newForm.value.Anonimo){
          newForm.value.ConRespuesta = false;
          newForm.value.AQuienesResponden = null;
        }
        // Asigna la versión limpia a newForm
        newForm.value.Observacions = cleanedObservations;
        newForm.value.IdFormulario = newForm.value.IdFormulario || '00000000-0000-0000-0000-000000000000';
        newForm.value.IdCreador = user?.value.idPersona;
        newForm.value.IdModificadoPor = user?.value.idPersona;
        const cleanForm = JSON.stringify(toRaw(newForm.value), null, 2); 
        console.log(cleanForm)
        await api.post(`api/Formularios`, cleanForm);
        await router.push('/formularios')
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const addRangeItems = (observacion) => {
      if (!observacion.ItemsObservacions) {
        observacion.ItemsObservacions = [];
      }

      const requiredItems = [
        { NombreItem: 'Minimo', ValorDeRango: 0, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' },
        { NombreItem: 'Maxima', ValorDeRango: 10, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' },
        { NombreItem: 'StepValue', ValorDeRango: 1, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' },
      ];

      // Agregar los ítems si no existen
      for (const item of requiredItems) {
        if (!observacion.ItemsObservacions.some(i => i.NombreItem === item.NombreItem)) {
          observacion.ItemsObservacions.push(item);
        }
      }
    };

    const deleteRangeItems = (observacion) => {
      if (observacion.ItemsObservacions.length>0) {
        //Se asegura de borrar solo cuando son items de rango
        if(observacion.ItemsObservacions[0].NombreItem=="Minimo"||observacion.ItemsObservacions[0].NombreItem=="Maxima"||observacion.ItemsObservacions[0].NombreItem=="StepValue"){
          observacion.ItemsObservacions = [];
        }
      }
    };

    watch(
      () => newForm.value.Observacions,
      (observacions) => {
        observacions.forEach((observacion) => {
          if (observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()) {
            addRangeItems(observacion);
          } else {
            deleteRangeItems(observacion);
          }
        });
      },
      { immediate: true, deep: true }
    );

    const cancelForm = async() => {
      await router.push('/formularios');
    };

    const toggleAddItem = (index) => {
      newForm.value.Observacions[index].showAddItem = !newForm.value.Observacions[index].showAddItem;
    };

    const confirmAddItem = (index) => {
      const newItem = newForm.value.Observacions[index].newItemName.trim();
      if (newItem) {
        newForm.value.Observacions[index].ItemsObservacions.push({ NombreItem: newItem, ValorDeRango :null, IdItemsObservacion: '00000000-0000-0000-0000-000000000000' });
        newForm.value.Observacions[index].newItemName = ''; // Limpia el campo
      }
      newForm.value.Observacions[index].showAddItem = false; // Oculta el campo después de agregar
    };

    const cancelAddItem = (index) => {
      newForm.value.Observacions[index].showAddItem = false; // Oculta el campo sin agregar
    };

    const removeItem = (index, indexItem) => {
      newForm.value.Observacions[index].ItemsObservacions.splice(indexItem, 1);
    };
    // Función para manejar la carga de archivos
    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (file) {
        try {
          loadingFile.value = true;
          const archivoData = new FormData();
          archivoData.append('archivo', file); // Agrega el archivo

          const response = await api.post(`api/Archivos`, archivoData, {
            params: {
              hotlink: true,
            },
            headers: {
              'Content-Type': 'multipart/form-data', // Asegúrate de enviar el tipo de contenido correcto
            },
          });
          console.log(response.data)
          //Si devuelve un enlace, significa que se subio bien, asi que hay que borrar la imagen anterior
          if(response.data.enlace && newForm.value.PortadaUrl){
            await api.delete(`api/Archivos/eliminar`, {
              params: {
                id: newForm.value.PortadaUrl.split('/').pop(),
              },
            });
          }
          // Suponiendo que la API devuelve la URL del archivo subido
          newForm.value.PortadaUrl = response.data.enlace; // Asigna la URL del archivo subido al campo ImagenUrl
          loadingFile.value = false;
        } catch (error) {
          console.error('Error al subir archivo:', error);
        }
      }
    };
    const fileInput = ref(null)
    const selectImage = () => {
      fileInput.value.click() // Activa el input de archivo
    }
    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      fetchTiposObservacion();
      fetchPersonas();
    });

    return {
      isAddingForm,
      newForm,
      addObservation,
      removeObservation,
      submit,
      cancelForm,
      tiposObservacion,
      toggleAddItem,
      confirmAddItem,
      cancelAddItem,
      currentValue,
      removeItem,
      t,
      moveUp,
      moveDown,
      isSaving,
      loadingPersonas,
      loadingCursosGrupos,
      loadingMaterias,
      selectPersona,
      filterPersonas,
      agregarPersona,
      cancelarAgregarPersona,
      eliminarPersona,
      handleFileUpload,
      selectImage,
      fileInput,
      loadingFile,
    };
  },
};
</script>

<style scoped>
/* Estilo para el botón cuando está seleccionado */
.btn-check:checked + label {
  background-color: var(--goethe-accent-claro-2); /* Cambia el color de fondo */
  color: var(--texto-principal); /* Cambia el color del texto */
  border-color: var(--goethe-accent-claro-2); /* Cambia el color del borde si lo deseas */
}

/* Estilo para el botón deseleccionado */
.btn-check + label {
  background-color: transparent; /* Color de fondo por defecto */
  color: var(--texto-principal); /* Color del texto por defecto */
  border-color: var(--goethe-accent-claro-3); /* Color del borde por defecto */
}
/* Estilo para el hover */
.btn-check + label:hover {
  background-color: var(--goethe-accent-claro-3); /* Cambia el color de fondo al hacer hover */
  cursor: pointer; /* Cambia el cursor al hacer hover */
}
/* Deshabilitar hover si está seleccionado */
.btn-check:checked + label:hover {
  background-color: var(--goethe-accent-claro-2); /* Mantiene el color del botón si está seleccionado */
  color: var(--texto-principal); /* Mantiene el color del texto si está seleccionado */
}
.position-relative {
position: relative;
}

.eliminar-comentario {
display: none;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}

.position-relative:hover .eliminar-comentario {
display: block;
}
</style>
